module.exports = __webpack_public_path__ + "static/media/2022_encourage_banner.568668a0.jpg";